<template>
  <div class="main">
    <!-- title -->
    <h3 class="title" content="edit" placement="bottom">
      Content Management - Office Locations
      <el-button
        style="width:180px"
        type="primary"
        @click="handleAdd()"
        v-if="$store.state.userLevel <= 2"
        >Create</el-button
      >
    </h3>
    <!-- toolbar, table & pagination share one panel -->
    <div class="client-panel">
      <div class="client-panel__toolbar">
        <columns-control
          :columns="columnsConfig"
          storage-key="cms.officeLocations.columns"
          @change="onColumnsChange"
        ></columns-control>
      </div>
      <el-table :data="tableData" >
        <el-table-column v-if="isColumnVisible('displayOrder')" prop="displayOrder" label="Order"></el-table-column>
        <el-table-column v-if="isColumnVisible('countryEn')" prop="countryEn" label="Country / Region"></el-table-column>
        <el-table-column v-if="isColumnVisible('cityEn')" prop="cityEn" label="Office Name / City"></el-table-column>
        <el-table-column v-if="isColumnVisible('addressEn')" prop="addressEn" label="Address"></el-table-column>
        <el-table-column v-if="isColumnVisible('post')" prop="post" label="Post">
            <template slot-scope="scope">{{scope.row.post?'Online':'Offline'}}</template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('updatedAt')" prop="updatedAt" label="Last update" :formatter="$commonjs.tableFormatDateTime"></el-table-column>
        <el-table-column label="Operation">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="top"
            >
              <em class="edit" style="margin-right:10px" @click="handleEdit(scope.row)"></em>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="Delete"
              placement="top"
            >
              <em class="delete" @click="handleDelete(scope.row)"></em>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- page -->
      <app-pagination
        @size-change="(v)=>{currentSize=v;currentPage=1;getList()}"
        @current-change="(v)=>{currentPage=v;getList()}"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :total="total"
        :page-size="currentSize"
      ></app-pagination>
    </div>
  </div>
</template>

<script>
import {
  officesList,
  officesDelete
} from "@/request/api";
export default {
  name: "officeLocation",
  data() {
    return {
      tableData: [],
      currentSize: 10,
      currentPage: 1,
      total: 0,
      formLabelWidth: "96px",
      formUser: {
        id: 0,
        username: "",
        password: "",
        roles: []
      },
      columnsConfig: [
        { prop: "displayOrder", label: "Order", visible: true },
        { prop: "countryEn", label: "Country / Region", visible: true },
        { prop: "cityEn", label: "Office Name / City", visible: true },
        { prop: "addressEn", label: "Address", visible: true },
        { prop: "post", label: "Post", visible: true },
        { prop: "updatedAt", label: "Last update", visible: true },
      ],
      visibleColumnProps: [
        "displayOrder",
        "countryEn",
        "cityEn",
        "addressEn",
        "post",
        "updatedAt",
      ],
    };
  },
  methods: {
    isColumnVisible(prop) {
      return this.visibleColumnProps.includes(prop);
    },
    onColumnsChange(visibleProps) {
      this.visibleColumnProps = visibleProps;
    },
    getList() {
      let params={
        page:this.currentPage -1,
        size:this.currentSize
      };
      officesList(params).then(res=>{
        this.tableData = res.data.content;
        this.total = res.data.totalElements;
      })
    },
    handleAdd() {
      this.$router.push({path:'/createOfficeLocation'})
    },
    handleEdit(row) {
      this.$router.push({path:'/editOfficeLocation/'+row.id})
    },
    handleDelete(row) {
        const h = this.$createElement;
        this.$msgbox({
          message:h('div',{style:'padding:15px 0'},[
            h('p',{style:'color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;'},'Are you sure to delete this record?'),
          ]),
          showCancelButton: true,
          confirmButtonText:'Confirm',
          cancelButtonText:'Cancel',
          confirmButtonClass:'msg_button_half',
          cancelButtonClass:'msg_button_half',
          closeOnPressEscape:false,
          closeOnClickModal:false,
          callback:(action,instance)=>{
            let button = action;
            if(button == 'confirm'){
              officesDelete(row.id).then(res=>{
                if(res.data.status == '00'){
                  this.$message.success('Reocrd is deleted');
                  this.getList();
                }else{
                  this.$message.error(res.data.msg)
                }
              })
            }
          }
        })
    },
  },
  created: function() {
    this.$emit("header", true);
    this.getList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.client-panel {
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
  overflow: hidden;
}

.client-panel__toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-bottom: 1px solid #e6ebee;
}

.client-panel /deep/ .el-table {
  border: none;
  border-radius: 0;
}

.client-panel /deep/ .app-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0;
  border-top: 1px solid #e6ebee;
}
</style>



// WEBPACK FOOTER //
// src/components/content/location/officeLocation.vue